import { NODE_TYPE_LABELS, type NodeType, summarizeNode } from "@velizhanin-dev/bot-scenario"
import { Field } from "@/shared/ui/form-field"
import { NativeSelect } from "@/shared/ui/native-select"
import type { EditorProps } from "../editor-props"
import { readString, withField } from "../editor-props"
import { issuesAt } from "../issues-text"

export function GotoEditor({ config, onChange, issues, draft }: EditorProps) {
	const flowId = readString(config, "flowId")
	const targets = draft.nodes.filter((node) => node.flowId === flowId && node.type !== "start")
	return (
		<div className="space-y-4">
			<Field label="Воронка" issues={issuesAt(issues, "flowId")}>
				<NativeSelect
					aria-label="Воронка"
					value={flowId}
					onChange={(event) =>
						onChange(withField({ ...config, flowId: event.target.value }, "nodeId", undefined))
					}
				>
					<option value="" disabled>
						Выберите воронку
					</option>
					{draft.flows.map((flow) => (
						<option key={flow.id} value={flow.id}>
							{flow.name}
						</option>
					))}
				</NativeSelect>
			</Field>
			<Field label="Блок" issues={issuesAt(issues, "nodeId")}>
				<NativeSelect
					aria-label="Блок"
					value={readString(config, "nodeId")}
					disabled={!flowId}
					onChange={(event) =>
						onChange(withField(config, "nodeId", event.target.value || undefined))
					}
				>
					<option value="">С начала воронки</option>
					{targets.map((node) => (
						<option key={node.id} value={node.id}>
							{NODE_TYPE_LABELS[node.type as NodeType] ?? node.type}:{" "}
							{summarizeNode(node, draft.flows, draft.tags)}
						</option>
					))}
				</NativeSelect>
			</Field>
		</div>
	)
}
